import {
  Box,
  Typography,
  Grid,
  Paper,
  Chip,
  Divider,
  List,
  ListItem,

  ListItemText,
  Button,
  CircularProgress, // 1. Import adicionado
} from '@mui/material';
import LocalFloristIcon from '@mui/icons-material/LocalFlorist';
import PetsIcon from '@mui/icons-material/Pets';
import { Header } from 'components/home';
import { ContainerForm } from 'components/shared/container_form';
import { TopNavBar } from 'components/top_nav_bar';
import { MenuProvider } from 'contexts/menu/menu_context';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
// import { useCuffaStore } from 'stores/cuffa/cuffa.store'; // Removido
import { CuffaAPI } from 'api/cuffa/cuffa.api';
import { useCuffaStore } from 'stores/cuffa/cuffa.store';
import { useEffect, useState } from 'react';

// --- ENUMS E INTERFACES (sem alteração) ---
export enum CuffaSanitaryAgencyEnum {
  SECRETARIA_SAUDE_MUNICIPIO = 'SECRETARIA DE SAÚDE DO MUNICÍPIO',
  SECRETARIA_SAUDE_ESTADO = 'SECRETARIA DE SAÚDE DO ESTADO',
}

export enum CuffaInspectionSealEnum {
  SERVICO_INSPECAO_MUNICIPAL_SIM = 'SERVIÇO DE INSPEÇÃO MUNICIPAL – SIM',
  SERVICO_INSPECAO_ESTADUAL_SISE = 'SERVIÇO DE INSPEÇÃO ESTADUAL – SISE',
  SERVICO_INSPECAO_FEDERAL_SIF = 'SERVIÇO DE INSPEÇÃO FEDERAL – SIF',
  SISTEMA_BRASILEIRO_INSPECAO_SISBI = 'SISTEMA BRASILEIRO DE INSPEÇÃO DE PRODUTOS DE ORIGEM ANIMAL – SISBI',
  SISTEMA_ESTADUAL_SUSAF_MT = 'SISTEMA ESTADUAL UNIFICADO DE SANIDADE AGROINDUSTRIAL FAMILIAR – SUSAF MT',
  SERVICO_INSPECAO_PEQUENO_PORTE_SIAPP = 'SERVIÇO DE INSPEÇÃO AGROINDUSTRIAL DE PEQUENO PORTE – SIAPP',
}

export const mapApiDataToForm = (apiData: any): IInspecaoFormValues => {
  const mappedData: IInspecaoFormValues = {
    hasVegetal: apiData.has_vegetal_licenses ?? false,
    hasAnimal: apiData.has_animal_inspections ?? false,
    possuiAlvaraSanitario: (apiData.vegetal_licenses?.length > 0) ? 'sim' : 'não',
    numeroRegistroAlvara: apiData.vegetal_licenses?.[0]?.license_number || '',
    orgaoEmissorAlvara: apiData.vegetal_licenses?.[0]?.issuing_body || '',
    dataEmissaoAlvara: apiData.vegetal_licenses?.[0]?.emission_date || '',
    possuiRegistroInspecao: (apiData.animal_inspections?.length > 0) ? 'sim' : 'não',
    selosSelecionados: apiData.animal_inspections?.map((selo: { seal_type: any; }) => selo.seal_type) || [],
  };

  if (apiData.animal_inspections) {
    apiData.animal_inspections.forEach((selo: { seal_type: any; registration_number: any; emission_date: any; }) => {
      mappedData[`numeroRegistro_${selo.seal_type}`] = selo.registration_number;
      mappedData[`dataEmissao_${selo.seal_type}`] = selo.emission_date;
    });
  }

  return mappedData;
};

interface IInspecaoFormValues {
  hasVegetal: boolean;
  hasAnimal: boolean;
  possuiAlvaraSanitario: string;
  numeroRegistroAlvara: string;
  orgaoEmissorAlvara: string;
  dataEmissaoAlvara: string;
  possuiRegistroInspecao: string;
  selosSelecionados: string[];
  [key: string]: any;
}

export const InspecaoProdutosVisualizar: React.FC = () => {
  const navigate = useNavigate();
  const { uuid } = useParams<{ uuid: string }>();

  // 2. Estado de 'loading' adicionado e 'useCuffaStore' removido
  const [dados, setDados] = useState<IInspecaoFormValues | null>(null);
  const [loading, setLoading] = useState(true);
  const dadosParciais = useCuffaStore(state => state.dadosParciais);

  // 3. useEffect reescrito para buscar e mapear os dados da API
  useEffect(() => {
    const fetchInspectionData = async () => {
      if (!uuid) {
        setLoading(false);
        return;
      }

      // Primeiro tenta restaurar do localStorage específico da coleta
      try {
        const storageKey = `cuffa-storage-${uuid}`;
        const stored = window.localStorage.getItem(storageKey);
        if (stored) {
          try {
            const parsed = JSON.parse(stored);
            const storedInspecao = parsed?.state?.dadosParciais?.inspecaoProdutos;
            if (storedInspecao) {
              setDados(storedInspecao);
              setLoading(false);
              return;
            }
          } catch (e) {
            console.warn('Falha ao parsear cuffa-storage', e);
          }
        }
      } catch (e) {
        console.warn('Erro ao acessar localStorage para cuffa-storage', e);
      }

      const local = dadosParciais?.inspecaoProdutos;
      if (local) {
        setDados(local);
        setLoading(false);
        return;
      }

      try {
        const response = await CuffaAPI.getDataByID(uuid);
        if (response && response.dados) {
          const apiData = response.dados;
          const mappedData = mapApiDataToForm(apiData);
          setDados(mappedData);
        } else {
          setDados(null);
        }
      } catch (error) {
        setDados(null);
      } finally {
        setLoading(false);
      }
    };
    fetchInspectionData();
  }, [uuid, dadosParciais]);

  // 4. Adicionados blocos para exibir o status de 'Carregando' e 'Erro'
  if (loading) {
    return (
      <MenuProvider>
        <TopNavBar />
        <Header title="Inspeção de Produtos" showBackButton />
        <Box width="100%" display="flex" justifyContent="center" alignItems="center" height="50vh">
          <CircularProgress />
          <Typography sx={{ ml: 2 }}>Carregando dados...</Typography>
        </Box>
      </MenuProvider>
    );
  }

  if (!dados) {
    return (
      <MenuProvider>
        <TopNavBar />
        <Header title="Inspeção de Produtos" showBackButton />
        <Box width="100%" display="flex" justifyContent="center" margin="2rem 0">
          <Typography>Não foi possível carregar os dados. Verifique o console para mais detalhes.</Typography>
        </Box>
      </MenuProvider>
    );
  }

  const formatCurrency = (value: number | string | undefined | null) => {
    if (value === undefined || value === null) return 'Não informado';
    const num = typeof value === 'string' ? Number(value) : value;
    if (Number.isNaN(num)) return String(value);
    return (num / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  const renderProdutosDetalhes = () => {
    if (!dados) return null;
    return (
      <>
        {dados.vegetalData && Array.isArray(dados.vegetalData) && dados.vegetalData.length > 0 && (
          <Paper elevation={0} sx={{ p: 3, mb: 4, border: '2px solid #388e3c', borderRadius: '8px' }}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Produtos Vegetais Inspecionados</Typography>
            <List>
              {dados.vegetalData.map((prod: any, idx: number) => (
                <Box key={prod.product_uuid || idx} mb={2}>
                  <ListItem>
                    <ListItemText
                      primary={prod.product_name || prod.product_uuid}
                      secondary={
                        <>
                          <div>Valor comercializado: {prod.commercialized_value !== undefined && prod.commercialized_value !== null ? formatCurrency(prod.commercialized_value) : 'Não informado'}</div>
                          <div>Volume comercializado: {prod.commercialized_volume !== undefined ? prod.commercialized_volume : 'Não informado'}</div>
                          <div>Unidade: {prod.measurement_unit || 'Não informado'}</div>
                          <div>Possui alvará sanitário: {prod.has_sanitary_license ? 'Sim' : 'Não'}</div>
                          {prod.has_sanitary_license && (
                            <>
                              <div>Número do alvará: {prod.license_number || 'Não informado'}</div>
                              <div>Órgão emissor: {prod.issuing_body || 'Não informado'}</div>
                              <div>Data de emissão: {prod.emission_date || 'Não informada'}</div>
                            </>
                          )}
                        </>
                      }
                    />
                  </ListItem>
                  {idx < dados.vegetalData.length - 1 && <Divider />}
                </Box>
              ))}
            </List>
          </Paper>
        )}
        {dados.animalData && Array.isArray(dados.animalData) && dados.animalData.length > 0 && (
          <Paper elevation={0} sx={{ p: 3, mb: 4, border: '2px solid #d32f2f', borderRadius: '8px' }}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Produtos Animais Inspecionados</Typography>
            <List>
              {dados.animalData.map((prod: any, idx: number) => (
                <Box key={prod.product_uuid || idx} mb={2}>
                  <ListItem>
                    <ListItemText
                      primary={prod.product_name || prod.product_uuid}
                      secondary={
                        <>
                          <div>Valor comercializado: {prod.commercialized_value !== undefined && prod.commercialized_value !== null ? formatCurrency(prod.commercialized_value) : 'Não informado'}</div>
                          <div>Volume comercializado: {prod.commercialized_volume !== undefined ? prod.commercialized_volume : 'Não informado'}</div>
                          <div>Unidade: {prod.measurement_unit || 'Não informado'}</div>
                          <div>Possui registro de inspeção: {prod.has_inspection_register ? 'Sim' : 'Não'}</div>
                          {prod.has_inspection_register && prod.inspection_seals && prod.inspection_seals.length > 0 && (
                            <>
                              <div>Selos:</div>
                              <ul style={{ margin: 0, paddingLeft: 16 }}>
                                {prod.inspection_seals.map((s: any, i: number) => (
                                  <li key={i}>
                                    {s.inspection_seal} - Nº: {s.register_number || 'Não informado'} - Data: {s.issue_date || 'Não informada'}
                                  </li>
                                ))}
                              </ul>
                            </>
                          )}
                        </>
                      }
                    />
                  </ListItem>
                  {idx < dados.animalData.length - 1 && <Divider />}
                </Box>
              ))}
            </List>
          </Paper>
        )}
      </>
    );
  };

  // O restante do código JSX continua o mesmo, pois ele já lê do estado 'dados'
  return (
    <MenuProvider>
      <TopNavBar />
      <Header title="Visualização da Inspeção de Produtos" showBackButton />
      <Box width="100%" display="flex" justifyContent="center" margin="2rem 0">
        <Box sx={{ maxWidth: '1152px', padding: '2rem', width: '100%' }}>
          <ContainerForm title="Selos de Inspeção" subtitle="Visualização dos dados de inspeção conforme origem do produto" width="100%">
            {/* Seção: Origem dos Produtos */}
            <Paper elevation={0} sx={{ p: 3, mb: 4, border: '2px solid #000', borderRadius: '8px' }}>
              <Typography variant="h6" fontWeight="bold" gutterBottom>Origem dos Produtos</Typography>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12} md={6}>
                  <Paper elevation={0} sx={{
                    p: 2,
                    height: '100%',
                    border: dados.hasVegetal ? '2px solid #2e7d32' : '2px solid #ccc',
                    borderRadius: '8px',
                    backgroundColor: dados.hasVegetal ? 'rgba(76, 175, 80, 0.1)' : 'transparent'
                  }}>
                    <Box display="flex" alignItems="center">
                      <LocalFloristIcon color={dados.hasVegetal ? "success" : "action"} sx={{ fontSize: 32, mr: 2 }} />
                      <Box>
                        <Typography variant="h6" fontWeight="bold">Produtos de Origem Vegetal</Typography>
                        <Typography variant="body2" color="text.secondary">Frutas, verduras, grãos e seus derivados.</Typography>
                        <Chip
                          label={dados.hasVegetal ? "Selecionado" : "Não selecionado"}
                          color={dados.hasVegetal ? "success" : "default"}
                          size="small"
                          sx={{ mt: 1 }}
                        />
                      </Box>
                    </Box>
                  </Paper>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Paper elevation={0} sx={{
                    p: 2,
                    height: '100%',
                    border: dados.hasAnimal ? '2px solid #d32f2f' : '2px solid #ccc',
                    borderRadius: '8px',
                    backgroundColor: dados.hasAnimal ? 'rgba(233, 30, 99, 0.1)' : 'transparent'
                  }}>
                    <Box display="flex" alignItems="center">
                      <PetsIcon color={dados.hasAnimal ? "error" : "action"} sx={{ fontSize: 32, mr: 2 }} />
                      <Box>
                        <Typography variant="h6" fontWeight="bold">Produtos de Origem Animal</Typography>
                        <Typography variant="body2" color="text.secondary">Carnes, laticínios, ovos, mel e seus derivados.</Typography>
                        <Chip
                          label={dados.hasAnimal ? "Selecionado" : "Não selecionado"}
                          color={dados.hasAnimal ? "error" : "default"}
                          size="small"
                          sx={{ mt: 1 }}
                        />
                      </Box>
                    </Box>
                  </Paper>
                </Grid>
              </Grid>
            </Paper>

            {renderProdutosDetalhes()}


            <Box marginTop="2rem" display="flex" justifyContent="center" gap="1rem">
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate(ROUTES.PRODUTOS_PROCESSADOS_VISUALIZAR.replace(':uuid', uuid ?? ''))}
              >
                Voltar
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  if (uuid) {
                    navigate(ROUTES.SELOS_AGREGACAO_CUFFA_VISUALIZAR.replace(':uuid', uuid));
                  }
                }}
              >
                Avançar
              </Button>
            </Box>
          </ContainerForm>
        </Box>
      </Box>
    </MenuProvider>
  );
};

export default InspecaoProdutosVisualizar;
